import React, { useEffect, useState, useId } from 'react'
import { dateHelpers, stringHelpers } from 'utils'
import Div100vh from 'react-div-100vh'
import { useTheme } from 'styled-components'
import { useDispatch } from 'react-redux'
import { Toggle } from '@dsny/dsny-component-library'
import {
  Info,
  Keyboardarrowdown,
  PlayArrowFilled,
  PauseFilled,
  SkipPreviousFilled,
  SkipNextFilled
} from '@dsny/dsny-component-library/icons'
import {
  AlbumArtLarge,
  Wrapper,
  TrackInfo,
  PlaybackControls,
  Time,
  TrackName,
  ArtistName,
  OptionsWrapper,
  TimeRow,
  ToggleContainer,
  IconContainer,
  IconWrapper
} from './ExpandedPlaybar.styles'
import { albumCovertArtPlaceholder } from 'images'
import TrackPlaylistDropdown from '../Dropdowns/PlaylistDropdown/TrackPlaylistDropdown'
import { PlayOptionsWrapper, PlayerIconWrapper } from './Playbar.styles'
import ProgressBar from '../ProgressBar'
import usePlayerControls from './usePlayerControls'
import PlayerActions from 'reducers/Player'

export default function ExpandedPlaybar({ toggleExpanded }) {
  const autoPlayToggleId = useId()
  const theme = useTheme()
  const dispatch = useDispatch()

  const {
    isPlaying,
    currentTime,
    displayDuration,
    selectedSong,
    isSliderDragging,
    setIsSliderDragging,
    handleTogglePlay,
    handleSkipBack,
    handleSkipFwd,
    hasNoSong,
    autoPlay,
    handleToggleAutoPlay
  } = usePlayerControls()
  const [sliderCurrentTime, setSliderCurrentTime] = useState(currentTime)

  useEffect(() => {
    if (!isSliderDragging) {
      setSliderCurrentTime(currentTime)
    }
  }, [currentTime, isSliderDragging])

  const handleSliderChange = (e) => {
    const value = e.target.value
    setIsSliderDragging(true)
    setSliderCurrentTime(value)
  }

  const handleSliderRelease = (e) => {
    const value = e.target.value
    dispatch(PlayerActions.seekTimeRequest(value))
    setSliderCurrentTime(value)
    setIsSliderDragging(false)
  }

  return (
    <Wrapper
      initial={{ opacity: 0, scale: 0.3 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', stiffness: 100, damping: 15 }}
    >
      <Div100vh>
        <OptionsWrapper>
          <IconContainer>
            <IconWrapper>
              <Info width={21} color={theme.colors.neutralW100} />
            </IconWrapper>
            <IconWrapper>
              <TrackPlaylistDropdown
                track={selectedSong}
                triggerStyles={{ display: 'flex', alignSelf: 'center' }}
              />
            </IconWrapper>
            <ToggleContainer>
              <Toggle
                id={autoPlayToggleId}
                checked={autoPlay}
                onChange={handleToggleAutoPlay}
                player={true}
                displayIcon={true}
                containerStyle={{
                  display: 'flex',
                  alignItems: 'center',
                  boxShadow: 'none'
                }}
                labelStyle={{ width: 58, height: 32, boxShadow: 'none' }}
              />
            </ToggleContainer>
          </IconContainer>
          <IconWrapper style={{ marginLeft: 'auto' }} onClick={toggleExpanded}>
            <Keyboardarrowdown width={21} color={theme.colors.neutralW100} />
          </IconWrapper>
        </OptionsWrapper>
        <AlbumArtLarge
          src={selectedSong?.coverart || albumCovertArtPlaceholder}
          alt="Album Art"
        />

        <TrackInfo>
          <TrackName>{selectedSong?.title}</TrackName>
          <ArtistName>{selectedSong?.artist}</ArtistName>
        </TrackInfo>

        <PlaybackControls>
          <ProgressBar
            value={isSliderDragging ? sliderCurrentTime : currentTime}
            defaultValue={0}
            min={0}
            className="cursor-pointer"
            max={displayDuration}
            onChange={handleSliderChange}
            onMouseUp={handleSliderRelease}
            onTouchEnd={handleSliderRelease}
          />
        </PlaybackControls>
        <TimeRow>
          <Time>{stringHelpers.formatTime(currentTime)}</Time>
          <Time>{dateHelpers.getStringFromSeconds(displayDuration)}</Time>
        </TimeRow>

        <PlayOptionsWrapper style={{ justifyContent: 'center' }}>
          <SkipPreviousFilled
            width={32}
            height={32}
            color={
              hasNoSong ? theme.colors.neutralW40 : theme.colors.neutralW100
            }
            onClick={handleSkipBack}
          />
          <PlayerIconWrapper
            $hasNoSong={hasNoSong}
            style={{ width: 50, height: 50 }}
          >
            {isPlaying && !hasNoSong ? (
              <PauseFilled
                width={32}
                height={32}
                color={theme.colors.neutralW20}
                onClick={handleTogglePlay}
              />
            ) : (
              <PlayArrowFilled
                width={32}
                height={32}
                color={
                  hasNoSong ? theme.colors.neutralW50 : theme.colors.neutralW20
                }
                onClick={handleTogglePlay}
              />
            )}
          </PlayerIconWrapper>
          <SkipNextFilled
            width={32}
            height={32}
            color={
              hasNoSong ? theme.colors.neutralW40 : theme.colors.neutralW100
            }
            onClick={handleSkipFwd}
          />
        </PlayOptionsWrapper>
      </Div100vh>
    </Wrapper>
  )
}
